









import { Prop, Component, Vue } from 'vue-property-decorator'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

// @ts-ignore
import VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor)

@Component
export default class InputRichTextEditor extends Vue {
    @Prop({ required: true }) content!: string

    onEditorChange({ html }) {
        this.$emit('input', html)
    }

    get options() {
        return {
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ header: 1 }, { header: 2 }],
                    [{ list: 'ordered'}, { list: 'bullet' }],
                    [{ align: [] }],
                    [{ color: [] }],
                    ['link', 'image'],
                    ['clean'],
                ],
            },
        }
    }
}
